import { Fund } from '../types';
import { useOne } from '@refinedev/core';

export const useFund = (fundId?: string) => {
  const { data, isLoading, refetch } = useOne<Fund>({
    resource: 'funds',
    id: fundId || '',
    queryOptions: {
      enabled: !!fundId,
    },
  });

  return {
    fund: data?.data,
    isLoading,
    refetch,
  };
};
